<template>
  <div class="field">
    <label class="label">
      {{name}}
      <span v-if="typeof required !== 'undefined'" class="has-text-danger">*</span>
      <span v-if="addTitle" class="is-size-7">{{ addTitle }}</span>
    </label>
    <div class="control" :class="{'is-flex': $slots.default, 'has-icons-left': hasIconSearch}">
      <span v-if="hasIconSearch" class="icon is-small is-left">
        <font-awesome-icon icon="magnifying-glass" />
      </span>
      <input class="input" :type="type" :placeholder="name" :value="modelValue" @input="event => $emit('update:modelValue', event.target.value)" :required="required" :disabled="disabled">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    modelValue: {
      type: [String, Number],
      default: ''
    },
    required: {
      type: Boolean,
      default: undefined
    },
    type: {
      type: String,
      default: 'text'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    addTitle: {
      type: String,
      default: ''
    },
    hasIconSearch: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue']
}
</script>